export { default } from './SpotGuideMoreInfo';
